import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  +%s Veel

  <span style="color:#85c1dc;">**FI:**</span>
  +%s Vielä

  <span style="color:#85c1dc;">**RU:**</span>
  Показать больше
*/
/* @__NO_SIDE_EFFECTS__ */
const m361 = msg(
  mf`+%s Veel`,
  mf`+%s Vielä`,
  mf`Показать больше`,
)

export { m361 as 'w.module.filter_bar.show_more' }